import * as React from 'react';

import {FlashBanner} from 'shells/flash-banner/flash-banner';
import {Link} from 'shells/link/link';

import styles from './sender-address-migration-banner.module.css';

export function SenderAddressMigrationBanner() {
    const shouldShowNotSendingWarningBanner = false;

    if (shouldShowNotSendingWarningBanner) {
        return (
            <div className={styles.container}>
                <FlashBanner type='error' hasBorder={true}>
                    <div className={styles.content}>
                        <p className={styles.text}>
                            Your messages have stopped sending because you have sender addresses
                            that require DNS records. Add these records to resume sending messages.
                        </p>
                        <Link
                            variant='primary'
                            href='https://support.nutshell.com/en/articles/8428864-campaigns-make-the-required-dkim-dns-record-update'
                            newTab={true}
                        >
                            Learn how
                        </Link>
                    </div>
                </FlashBanner>
            </div>
        );
    }

    return null;
}
